import React, { useState } from 'react';
import './DonationPay.scss';
import DonationStepper from '../DonationStepper';
import Grid from '@material-ui/core/Grid';
import {
  HintField,
  InputField,
  LabelField,
  SelectField,
  MyCheckbox,
} from 'components';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { makeStyles } from '@material-ui/core/styles';
import { emailRegex } from 'utils/validation';
import TributeInformation from '../../NewFinance/NewCharge/ChargeType/TributeInformation';
import thousands from 'thousands';
import { toastr } from 'react-redux-toastr';
import MyButton from 'components/MyButton';

const useStyles = makeStyles((theme) => ({
  root: {
    // margin: theme.spacing(2)
    marginLeft: '0',
    marginRight: '50px',
  },
}));

const DonationPay = ({ formik }) => {
  const [honorChecked, setHonorChecked] = useState(false);
  const [honor, setHonor] = useState('honor');
  const [tributeCheck, setTributeCheck] = useState(false);

  const classes = useStyles();


  const handleDonate = () => {
    if (
      !formik?.values?.card_number ||
      !formik?.values?.expiry ||
      !formik?.values?.cvc
    ) {
      toastr.info('Validation', 'please fill all mandatory fields', {
        position: 'top-center',
      });
      return;
    }
    if (honorChecked && !formik?.values?.hornee_name) {
      toastr.info('Validation', 'please enter a honor name', {
        position: 'top-center',
      });
      return;
    }
    if (
      tributeCheck &&
      (!formik?.values?.tribute_type ||
        !formik?.values?.donation_recipient_salutations ||
        !formik?.values?.donation_recipient_name ||
        !formik?.values?.donor_salutation ||
        !formik?.values?.donor_name ||
        !formik?.values?.email ||
        !formik?.values?.address)
    ) {
      toastr.info(
        'Validation',
        'please fill all mandatory tribute information fields',
        {
          position: 'top-center',
        }
      );
      return;
    }
    if (tributeCheck && !emailRegex.test(formik?.values?.email)) {
      toastr.info('Validation', 'please enter a valid email', {
        position: 'top-center',
      });
      return;
    }
    toastr.success('Coming Soon');
  };

  return (
    <>
      <div className="donation__content">
        <DonationStepper activeStep={2} />
        <div className="DonationCause__content">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <InputField
                type="number"
                title="Card Number"
                mandatory
                {...{
                  // formik,
                  name: 'card_number',
                  placeholder: 'Card Number',
                  value: formik?.values?.card_number,
                }}
                handleChange={(e) => {
                  formik.setFieldValue('card_number', e?.target?.value);
                }}
                inputClassName="donation__input"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField
                type="number"
                title="Expiry"
                mandatory
                {...{
                  // formik,
                  name: 'expiry',
                  placeholder: 'Expiry (MM/YY)',
                  value: formik?.values?.expiry,
                }}
                handleChange={(e) => {
                  formik.setFieldValue('expiry', e?.target?.value);
                }}
                inputClassName="donation__input"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputField
                type="number"
                title="CVC"
                mandatory
                {...{
                  // formik,
                  name: 'cvc',
                  placeholder: 'CVC',
                  value: formik?.values?.cvc,
                }}
                handleChange={(e) => {
                  formik.setFieldValue('cvc', e?.target?.value);
                }}
                inputClassName="donation__input"
              />
            </Grid>
            {/* summary */}
            <Grid item xs={12}>
              <div className="summaryPayText">Summary</div>
            </Grid>
            {formik?.values?.causeInfo?.map((item, idx) => (
              <Grid item xs={12} key={idx}>
                <div className="couses__amount d-flex alien-items-center justify-content-between">
                  <div>{item?.cause}</div>
                  <div>
                    ${' '}
                    {item?.amount
                      ? thousands((+item?.amount).toFixed(2))
                      : '0.00'}
                  </div>
                </div>
              </Grid>
            ))}
            <hr style={{ width: '100%', color: '#404253' }} />
            <Grid item xs={12}>
              <div className="total__amount d-flex alien-items-center justify-content-between">
                <div>Total</div>
                <div>
                  ${' '}
                  {formik?.values?.causeInfo?.reduce(
                    (acc, c) => acc + +c?.amount,
                    0
                  )
                    ? thousands(
                        (+formik?.values?.causeInfo?.reduce(
                          (acc, c) => acc + +c?.amount,
                          0
                        )).toFixed(2)
                      )
                    : '0.00'}
                </div>
              </div>
            </Grid>
            {/* checkbox honor */}
            <Grid item xs={12}>
              <div
                style={{
                  paddingLeft: '8px',
                  height: '48px',
                  marginTop: '15px',
                }}
              >
                <label
                  htmlFor="honor"
                  className="d-flex align-items-center h-100 checkbox__label"
                >
                  <MyCheckbox
                    handlechange={(e) => setHonorChecked(e.target.checked)}
                    checked={honorChecked}
                    name="checkboxHonor"
                    id="honor"
                  />
                  Give in honor or memory of someone
                </label>
              </div>
            </Grid>
            {honorChecked && (
              <div className="honor__content">
                <Grid xs={12}>
                  <FormControl className='mb-4'>
                    <RadioGroup
                      row
                      aria-labelledby="honor-memory-radio-buttons-group-label"
                      name="honor_memory"
                      onChange={(e) => setHonor(e.target.value)}
                      value={honor}
                    >
                      <FormControlLabel
                        value="honor"
                        control={<Radio />}
                        label="In Honor"
                        className={classes.root}
                      />
                      <FormControlLabel
                        value="memory"
                        control={<Radio />}
                        label="In Memory"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid xs={12}>
                  <InputField
                    type="text"
                    title="Honoree Name"
                    mandatory
                    {...{
                      // formik,
                      name: 'hornee_name',
                      placeholder: 'Honoree name',
                      value: formik.values.hornee_name,
                    }}
                    handleChange={(e) => {
                      formik.setFieldValue('hornee_name', e?.target?.value);
                    }}
                    inputClassName="donation__input honor__input"
                  />
                </Grid>
                {/* tribute check box */}
                <Grid item xs={12}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '8px',
                      height: '48px',
                      width: '100%',
                      marginTop: '15px',
                    }}
                  >
                    <label
                      htmlFor="tribute-letter"
                      className="d-flex align-items-center h-100 checkbox__label"
                    >
                      <MyCheckbox
                        handlechange={(e) => setTributeCheck(e.target.checked)}
                        checked={tributeCheck}
                        name="checkboxTributeLetter"
                        id="tribute-letter"
                      />
                      Add a tribute letter
                    </label>
                  </div>
                </Grid>
              </div>
            )}
            {tributeCheck && (
              <div className="tribute__container">
                <div className="tribute_information_text">
                  Tribute Information
                </div>
                <div className="tribute__content__extDo">
                  <TributeInformation formik={formik} />
                </div>
              </div>
            )}
          </Grid>
        </div>
      </div>
      <div className="d-flex justify-content-end my-5">
        <MyButton
          className="btn next__btn"
          style={{ width: '100px', marginLeft: 10, height: '45px' }}
          onClick={handleDonate}
          content={<div className="Next_btn">Donate</div>}
        />
      </div>
    </>
  );
};

export default DonationPay;
